'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autowhatever/dist/index.js
// module id = 251
// module chunks = 0